<div class="modal-header border-0">
  <h6 class="modal-title fw-semibold">รายละเอียดประวัติการลงทะเบียนสิทธิ UC</h6>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body border-0">
  <div class="row mb-3">
    <label for="personalId" class="col-form-label col-xl-6 text-end text-muted">เลขประจำตัวประชาชน</label>
    <div class="col-xl-6">
      <input id="personalId" [ngModel]="item.personalId" formDisabled>
    </div>
  </div>
  <div class="row mb-3">
    <label for="fullName" class="col-form-label col-xl-6 text-end text-muted">ชื่อ-นามสกุล</label>
    <div class="col-xl-6">
      <input id="fullName" [ngModel]="item.personalData?.fullNameWithoutTitle" formDisabled>
    </div>
  </div>
  <div class="row mb-3">
    <label for="sexDesc" class="col-form-label col-xl-6 text-end text-muted">เพศ</label>
    <div class="col-xl-6">
      <input id="sexDesc" [ngModel]="sexDesc[item.personalData?.sex]" formDisabled>
    </div>
  </div>
  <div class="row mb-3">
    <label for="birthDate" class="col-form-label col-xl-6 text-end text-muted">วันเดือนปีเกิด</label>
    <div class="col-xl-6">
      <input id="birthDate" [ngModel]="item.personalData?.displayBirthDate" formDisabled>
    </div>
  </div>
  <div class="row mb-3">
    <label for="regTypeName" class="col-form-label col-xl-6 text-end text-muted">ประเภทการลงทะเบียน</label>
    <div class="col-xl-6">
      <input id="regTypeName" [ngModel]="item.regTypeName" formDisabled>
    </div>
  </div>
  <div class="row mb-3">
    <label for="regProvince" class="col-form-label col-xl-6 text-end text-muted">จังหวัดที่ลงทะเบียน</label>
    <div class="col-xl-6">
      <input id="regProvince" [ngModel]="item.regProvince?.name" formDisabled>
    </div>
  </div>
</div>
<table class="table table-responsive-xl mb-0">
  <thead>
  <tr>
    <th nowrap scope="col" class="text-center">ลำดับที่</th>
    <th nowrap scope="col">ประเภทเอกสาร</th>
    <th nowrap scope="col" class="text-center">แสดง/ดาวน์โหลด</th>
  </tr>
  </thead>
  <tbody>
    @for (doc of documents; let i = $index; track doc.id) {
      <tr>
        <th scope="row" class="text-center">{{ i + 1 | number }}</th>
        <td>
          <i class="bi bi-paperclip text-muted me-2"></i>{{ doc?.fileGroupName }}
        </td>
        <td nowrap>
          <button *ngIf="isImage(doc?.mimeType)" class="btn btn-light border me-2 rounded-pill btn-sm"
                  type="button" (click)="showImage(doc)">
            <i class="bi bi-eye me-2"></i>
            <span class="d-none d-xl-inline-block">แสดง</span>
          </button>
          <button *ngIf="isPdf(doc?.mimeType)" class="btn btn-light border me-2 rounded-pill btn-sm" type="button"
                  (click)="showDoc(doc)">
            <i class="bi bi-eye me-2"></i>
            <span class="d-none d-xl-inline-block">แสดง</span>
          </button>
          <button class="btn btn-primary rounded-pill btn-sm" type="button" (click)="downloadDoc(doc)">
            <i class="bi bi-download me-2"></i>
            <span class="d-none d-xl-inline-block">ดาวน์โหลด</span>
          </button>
        </td>
      </tr>
    } @empty {
      <tr>
        <td colspan="26">
          <app-not-found></app-not-found>
        </td>
      </tr>
    }
  </tbody>
</table>
<div class="modal-footer">
<!--  <button type="button" class="btn btn-danger" (click)="activeModal.close('Close click')">ปิด</button>-->
</div>
